import { AppThunk } from 'store';

import { NotificationsApi } from 'api/NotificationsApi';

import { setIsFirstLoading, setNewNotifications } from './notificationsSlice';

export const fetchNotificationData = (): AppThunk => async (dispatch) => {
  const data = await NotificationsApi.fetchNotifications();

  dispatch(
    setNewNotifications({
      newLikes: data?.likes?.count_new,
      newMatches: data?.matches?.count_new,
      newVisits: data?.visits?.count_new,
    })
  );
  dispatch(setIsFirstLoading());
};
